import yup from 'utils/yup';

export const typesValidationSchema = yup.lazy((values: Record<string, boolean> = {}) =>
  yup
    .object(Object.fromEntries(Object.keys(values).map((key) => [key, yup.boolean().default(false)])))
    .test('at-least-one', 'Select at least one event type', (vals: boolean) => Object.values(vals || {}).some(Boolean)),
);
